/* eReaders Service — comportamenti del tema: menu, copia codice, linguette prezzi, acquisto.
   Le scritte arrivano da window.testi (layout/theme.liquid), nella lingua della pagina. */
(function () {
  const T = window.testi || {};
  const it = (T.lingua || 'it') === 'it';
  const euro = cents => {
    const n = (cents / 100).toLocaleString(it ? 'it-IT' : 'en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return it ? n + ' €' : '€' + n;
  };
  const riempi = (testo, valori) => String(testo || '').replace(/\{(\w+)\}/g, (m, k) => (k in valori ? valori[k] : m));
  const radice = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let tt;
  function toast(html) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(() => t.classList.remove('show'), 4500);
  }

  // Menu su telefono
  const head = document.getElementById('head');
  const menuBtn = document.getElementById('menubtn');
  if (head && menuBtn) {
    menuBtn.addEventListener('click', () => {
      const open = head.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    head.querySelectorAll('.mnav a').forEach(a => a.addEventListener('click', () => {
      head.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }));
  }

  // Copia codice sconto / indirizzo email
  document.addEventListener('click', e => {
    const c = e.target.closest('[data-copy]');
    if (!c) return;
    const txt = c.dataset.copy, old = c.textContent;
    const fatto = () => { c.textContent = T.copiato; setTimeout(() => { c.textContent = old; }, 1500); };
    try { navigator.clipboard.writeText(txt).then(fatto, () => toast(T.copiaAMano + txt)); } catch (err) { toast(T.copiaAMano + txt); }
  });

  // Linguette dei prezzi
  document.querySelectorAll('[data-tabs]').forEach(box => {
    const root = box.closest('section') || document;
    box.addEventListener('click', e => {
      const b = e.target.closest('[data-tab]');
      if (!b) return;
      box.querySelectorAll('[data-tab]').forEach(x => x.setAttribute('aria-selected', x === b));
      root.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== b.dataset.tab; });
    });
  });

  // Pagina d'acquisto
  const form = document.querySelector('[data-buy]');
  if (!form) return;
  const tot = form.querySelector('[data-total]');
  const hint = form.querySelector('[data-foto-hint]');
  const q = form.querySelector('input[name="quantity"]');
  const msg = form.querySelector('[data-msg]');
  const scelto = name => form.querySelector(`input[name="${name}"]:checked`);

  function aggiorna() {
    const v = scelto('id');
    const f = scelto('foto');
    if (!v) return;
    const prezzo = Number(v.dataset.price) + (f ? Number(f.dataset.price || 0) : 0);
    if (tot) tot.textContent = euro(prezzo);
    if (hint) {
      const n = f ? Number(f.dataset.n || 0) : 0;
      const tutte = v.dataset.inter;
      const valori = { taglia: v.dataset.size, n, tutte };
      valori.su = tutte ? riempi(T.fotoSu, valori) : '';
      valori.totale = tutte ? riempi(T.fotoTotale, valori) : '';
      hint.innerHTML = n ? riempi(n === 1 ? T.fotoUna : T.fotoPiu, valori) : hint.dataset.vuoto;
    }
  }
  form.addEventListener('change', aggiorna);
  aggiorna();

  form.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => {
    q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.q));
  }));

  async function aggiungi() {
    const v = scelto('id');
    const f = scelto('foto');
    const n = Math.max(1, parseInt(q.value, 10) || 1);
    const items = [{ id: Number(v.value), quantity: n }];
    if (f && f.value) items.push({ id: Number(f.value), quantity: n });
    const r = await fetch(radice + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.description || T.erroreCarrello);
    }
    const c = await fetch(radice + 'cart.js').then(x => x.json()).catch(() => null);
    const cn = document.getElementById('cartn');
    if (c && cn) cn.textContent = c.item_count;
    return { v, f, n };
  }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const subito = e.submitter && e.submitter.name === 'checkout';
    const bottoni = form.querySelectorAll('button[type="submit"]');
    bottoni.forEach(b => { b.disabled = true; });
    if (msg) { msg.textContent = ''; msg.classList.remove('err'); }
    try {
      const { v, f, n } = await aggiungi();
      if (subito) { window.location.href = radice + 'checkout'; return; }
      const nf = f && f.value ? Number(f.dataset.n) : 0;
      const foto = nf ? ' ' + (nf === 1 ? T.conFotoUna : riempi(T.conFoto, { n: nf })) : '';
      const cosa = `${form.dataset.nome}, ${T.pacchetto} ${v.dataset.size}${foto}${n > 1 ? ' × ' + n : ''}`;
      toast(`<span>${T.nelCarrello} ${cosa}</span><a href="${radice}cart">${T.vaiAlCarrello}</a>`);
    } catch (err) {
      if (msg) { msg.textContent = err.message; msg.classList.add('err'); }
    } finally {
      bottoni.forEach(b => { b.disabled = false; });
    }
  });
})();
